export default "__VITE_ASSET__5961af84__"